<div style="background: #ffeeff" class="h-100 overflow-auto crm-scroll">
  <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' Ringostat'"></app-sidebar-header>
  <mat-card class="shadow-none bg-transparent">
    <mat-card-content class="m-3 p-3 bg-white rounded-2">
      <div class="d-flex align-items-center gap-3">
        <img
          style="height: 150px; width: 150px"
          src="/assets/svgs/integrations/ringostat-logo.svg"
          alt="Ringostat logo"
        />
        <p>
          <span class="fw-bold">{{ 'integration' | translate }}:</span>
          <span class="text-success"> {{ keys.length ? 'встановлена ' : 'не встановлена' }}</span>
        </p>
      </div>

      @if (form) {
        <div [formGroup]="form">
          <p class="my-2">API-ключ</p>
          <div class="px-3">
            <app-text-field
              [formControl]="form.controls.api_key"
              [required]="true"
              [error]="isFormSubmitted && form.controls.api_key.status === 'INVALID'"
            >
            </app-text-field>
            @if (isFormSubmitted && form.controls.api_key.status === 'INVALID') {
              <div class="d-flex align-items-center">
                <span style="color: #ff381a; font-size: var(--font-xs); margin-top: 8px"
                  >{{ 'field_cannot_be_empty' | translate }}.</span
                >
              </div>
            }
            <div class="mr-3 gap-3 d-flex align-items-center justify-content-end">
              <app-button [disabled]="!this.keys.length" class="float-end" btnType="icon" (onChangeClick)="deleteApi()"
                ><app-icon>delete</app-icon></app-button
              >
              <app-button class="float-end my-2 me-2" (onChangeClick)="onSubmit()">
                @if (!this.keys.length) {
                  <span>{{ 'add' | translate }}</span>
                }
                @if (this.keys.length) {
                  <span>{{ 'update' | translate }}</span>
                }
              </app-button>
            </div>
          </div>
        </div>
      }
    </mat-card-content>

    <mat-card-footer class="m-3 p-3 bg-white rounded-2 text-secondary">
      {{ 'integration_setup_is_very_simple_and_fast' | translate }}.
      {{ 'to_connect_your_integration,_you_need_to_enter_the_API_key_in_the_form' | translate }}.
    </mat-card-footer>
  </mat-card>
</div>
